import { useEffect, useRef, useState } from 'react'
import { TotalsContainer } from './SaF.styles'
import { SaFData } from './SaF.types'
import SaFNodePair from './SaFNodePair'
import { getTotalsForNodes } from './safUtils/safUtils'
import { useTranslation } from 'react-i18n-lite'

type SaFTotalsProps = {
  nodesByDepth: SaFData['nodes'][]
}

export default function SaFTotals({ nodesByDepth }: SaFTotalsProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState<number | string>('auto')

  useEffect(() => {
    if (containerRef.current) {
      setHeight(containerRef.current.scrollHeight)
    }
  }, [])

  const { t } = useTranslation()

  return (
    <TotalsContainer style={{ height }} ref={containerRef}>
      {nodesByDepth.map((currentNodes, depth) => {
        const { outValue, inValue, remainingStock, y1 } =
          getTotalsForNodes(currentNodes)

        return (
          <SaFNodePair
            key={depth}
            x0={currentNodes[0].x0}
            y0={0}
            description={t('saf.totals')}
            complement=''
            sideNumber
            {...{ y1, inValue, outValue, remainingStock }}
            colors={[
              { background: '#FFFFFF', text: '#000000', border: '#ABBED1' },
              { background: '#FFFFFF', text: '#000000', border: '#ABBED1' }
            ]}
          />
        )
      })}
    </TotalsContainer>
  )
}
